import { EReturnStatus } from 'enums';

// Stitches S6. The key matches the API registry (erp-api src/public/featureFlags/feature-flags.ts).
export const finalStockOutFeatureFlag = 'stock.finalStockOut';

// The write-off action appears on a return only when the tenant has the flag, the user may create
// final stock outs, and the return is Completed (only then has its stock come back).
export const shouldShowFinalStockOutAction = ({
  featureEnabled,
  canCreate,
  returnStatus,
}: {
  featureEnabled: boolean;
  canCreate: boolean;
  returnStatus?: string;
}) => featureEnabled && canCreate && returnStatus === EReturnStatus.COMPLETED;

export const writtenOffQuantityByProduct = (
  finalStockOuts: { quantity: number; productVariant?: { id: string } | null }[],
) =>
  finalStockOuts.reduce<Record<string, number>>((totals, finalStockOut) => {
    const productVariantId = finalStockOut.productVariant?.id;
    if (productVariantId) {
      totals[productVariantId] = (totals[productVariantId] ?? 0) + finalStockOut.quantity;
    }
    return totals;
  }, {});

export const remainingToWriteOff = (returnedQuantity: number, writtenOffQuantity: number) =>
  Math.max(returnedQuantity - writtenOffQuantity, 0);
